/**
 * Auto-init for the two carousel patterns legacy + TSX-authored landings still
 * ship as raw markup. The web component strips inline <script> tags from
 * manifest HTML for security, so any carousel that needs JS has to be wired
 * here, inside our trusted runtime, against well-known class-name conventions.
 *
 * Implementations live in sibling files:
 *
 *   - `./testimonial-rotator.ts`  custom layered rotator (no off-the-shelf lib)
 *   - `./owl-pager.ts`            embla-driven horizontal pager
 *
 * Both initialisers are no-ops when their markup is absent — safe to call
 * against every shadow root.
 */

import { initTestimonialRotator } from './testimonial-rotator'
import { initOwlPager } from './owl-pager'

export function initLegacyCarousels(root: ShadowRoot | Document): void {
  initTestimonialRotator(root)
  initOwlPager(root)
}
